import React, {useEffect, useRef, useState} from 'react'
import Select, {components} from 'react-select'
import axios from 'axios'
import Cookies from 'js-cookie'

import * as constants from 'constants/index.js'

import {Card, CardBody, Col, Container, Row,} from 'reactstrap'
import CreateEditDelivery from "@pages/job-booker/CreateEditDelivery";
import AsyncSelect from 'react-select/async';
import notify from '@utils/notify';


export default function CreateNewDeliveryTask({setShowCreateNew, updateData}) {
    const [token, setToken] = useState('')
    const [jobData, setJobData] = useState({})
    const [allTasks, setAllTasks] = useState([])
    const [customer, setCustomer] = useState({})
    const [taskIndex, setTaskIndex] = useState(0)
    const [sendingData, setSendingData] = useState({})
    const [vehicleOption,setVehicleOption] = useState([])
    const [loading, setLoading] = useState(false)
    const [updateCreated, setUpdateCreated] = useState(false)
    const [disabled, setDisabled] = useState('')
    const [drivers, setDrivers] = useState([])
    const [regNos, setRegNos] = useState([])
    const [vehicle, setVehicle] = useState({})

    useEffect(() => {
        const grs_token = Cookies.get('grs_token')
        setToken(grs_token)

        const source = axios.CancelToken.source()

        const fetchData = async () => {
            try {
                const response = await axios({
                    method: 'GET',
                    url: `${constants.FLEET_URL}/job-booker/vehicles-available`,
                    headers: {
                        Authorization: `Bearer ${grs_token}`,
                    },
                    cancelToken: source.token,
                })
                const _regNos = response.data.data
                let _regNos_array = [];
                _regNos.map(_regNo => {
                    return _regNos_array.push({
                        ..._regNo,
                        value: _regNo.id,
                        label: _regNo.stock_no,
                    })
                })
                setRegNos(_regNos_array)
                const drivers = await axios({
                    method: 'GET',
                    url: `${constants.FLEET_URL}/job-booker/get-available-drivers`,
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                })
                if (drivers?.data.data.length) {
                    setDrivers(drivers?.data.data)
                }
                setLoading(false)
            } catch (error) {
                if (axios.isCancel(error)) {
                    console.log('Request canceled :: ', error)
                } else {
                    console.error('error :: ', error)
                    notify.warning('Warning', error.response ? error.response.statusText : 'Error occurred!')
                }
            }
        }

        fetchData()

        return () => {
            source.cancel()
        }
    }, [])

    const ValueContainer = ({children, ...props}) => {
        return (
            components.ValueContainer && (
                <components.ValueContainer {...props}>
                    {!!children && (
                        <i
                            className="fa fa-search"
                            aria-hidden="true"
                            style={{position: 'absolute', left: 6,}}
                        />
                    )}
                    {children}
                </components.ValueContainer>
            )
        );
    };

    const styles = {
        valueContainer: base => ({
            ...base,
            paddingLeft: 24
        })
    }
    const updateCollectionData = (index) => {
        let tempTasks = allTasks
        tempTasks[index] = sendingData
        setUpdateCreated(false)
        setAllTasks(tempTasks)
    }
    const addToCollection = () => {
        let tempData = sendingData
        tempData.customer_id = jobData.customer_id
        tempData.customer_email = jobData.customer_email
        tempData.vehicle_id = vehicle.id
        if (tempData.task_type === 'grs_collection') {
            tempData.driver_getter_phone = '01646 603 872'
            tempData.driver_getter_address = 'GRS Motor Group Ltd, Unit 12 & 13, Priory Park, Milford Haven, SA73 2DA'
        }
        setTaskIndex(allTasks.length + 1)
        setAllTasks([
            ...allTasks,
            tempData
        ])
    }
    const selectItem = (index) => {
        setUpdateCreated(true)
        return allTasks[index]
    }

    const sendData = async () => {
        const response = await axios({
            method: 'POST',
            url: `${constants.FLEET_URL}/job-booker/create-delivery-task`,
            data: allTasks,
            headers: {
                Authorization: 'Bearer ' + token
            }
        })
        if (response.status === 200) {
            setShowCreateNew(false)
            updateData()
        }
        // history.push(`/admin/vehicle-details?id=${id}`)
    }

    const checkData = (data) => {
        let isDisabled = false
        setSendingData(data)
        let required = ['customer_address', 'customer_name', 'customer_phone', 'customer_postal_code']
        for (let key in data) {
            if (required.includes(key) && (data[key] === null || data[key] === "" || data[key] === undefined)) {
                isDisabled = true;
                break
            }
        }
        setDisabled(isDisabled)
    }
    const promiseOptions = inputValue => {
        if (inputValue.length < 2) {
            return
        } else {
            return new Promise(resolve => {
                setTimeout(() => {
                    resolve(getCustomers(inputValue));
                }, 1000);
            });
        }
    }
    const setJobDataValue = (customer) => {

        let tempData = {}
        tempData.customer_email = customer.email
        tempData.customer_id = customer.id
        tempData.customer_name = customer.full_name
        tempData.customer_address = customer.address
        tempData.customer_phone = customer.mobile_number
        tempData.customer_postal_code = customer.postal_code
        setJobData({...jobData,...tempData})
        setCustomer(customer);
    }
    const getCustomers = async (value) => {
            try {
                const response = await axios({
                    method: 'GET',
                    url: constants.API_URL + '/customer',
                    headers: {
                        Authorization: 'Bearer ' + token
                    },
                    params: {
                        search: value,
                    },
                })
                const data = response.data
                const returnData = data.data;
                return returnData;
            } catch (error) {
                setLoading(false);
                if (axios.isCancel(error)) {
                    console.log('Request canceled :: ', error)
                } else {
                    console.error('error :: ', error)
                    notify.warning(error.response.data.message ? error.response.data.message : error.response.statusText)
                }
            }


    }
    return (
        <>
            {/*<CardsHeader name="Fleets" parentName="Job Management" currentName="Create" />*/}
            <Card>
                <CardBody>
                    <Container style={{minHeight: 'calc(100vh - 128px)'}}>
                        <Row className={'mb-3'}>
                             <Col md={6} sm={12} xs={12}>

                                         <label className="form-control-label">Vehicle</label>
                                         <Select
                                             options={regNos}
                                             className="basic-single"
                                             classNamePrefix="select"
                                             isSearchable={true}
                                             name="Please enter the Vehicle Reg. Number for applying the checklist"
                                             components={{
                                                 DropdownIndicator: () => null,
                                                 IndicatorSeparator: () => null,
                                                 ValueContainer
                                             }}
                                             placeholder={vehicle.stock_no ? vehicle.stock_no : 'Reg. Number'}
                                             styles={styles}
                                             onChange={value => {
                                                 setJobData({...jobData,...value})
                                                 setVehicle(value);
                                             }}
                                         />
                                     {/*<Col md={2} sm={12} xs={12}>*/}
                                     {/*    <Button className="w-100" style={{backgroundColor: "#ec6409", color: 'white'}}*/}
                                     {/*            type="button" onClick={() => searchVehicle()}>Search</Button>*/}
                                     {/*</Col>*/}
                             </Col>
                             <Col  md={6} sm={12} xs={12}>
                                         <label className="form-control-label">Customer</label>
                                         <AsyncSelect
                                             loadOptions={promiseOptions}
                                             className="basic-single"
                                             classNamePrefix="select"
                                             getOptionLabel={option => option['full_name']}
                                             getOptionValue={option => option['id']}
                                             onChange={value => {
                                                 setJobDataValue(value)

                                             }}
                                             placeholder="Search..."
                                             components={{
                                                 DropdownIndicator: () => null,
                                                 IndicatorSeparator: () => null,
                                             }}
                                         />
                                     {/*<Col md={2} sm={12} xs={12}>*/}
                                     {/*    <Button className="w-100" style={{backgroundColor: "#ec6409", color: 'white'}}*/}
                                     {/*            type="button" onClick={() => searchVehicle()}>Search</Button>*/}
                                     {/*</Col>*/}
                             </Col>
                        </Row>
                        {Object.values(jobData).length && Object.values(customer).length && Object.values(vehicle).length ?
                             <CreateEditDelivery
                                                loading={loading}
                                                setShowCreateNew={setShowCreateNew}
                                                jobData={jobData}
                                                drivers={drivers}
                                                selectItem={selectItem}
                                                setOption={setVehicleOption}
                                                vehicleOption={vehicleOption}
                                                updateCreated={updateCreated}
                                                updateCollectionData={updateCollectionData}
                                                allTasks={allTasks}
                                                index={taskIndex}
                                                disabled={disabled} save={sendData} addToCollection={addToCollection}
                                                checkData={checkData}>
                            </CreateEditDelivery> : <></>}
                    </Container>
                </CardBody>
            </Card>
        </>
    )
}